<template>
  <div>
    <div class="center-align push-top" @click="hideTooltip()">
      <div class="tuto-buttons">
        <BtnDownloadExcel class="tuto-button" />
        <BtnUploadExcel class="tuto-button" />
      </div>
      <div class="tooltip-wrapper">
        <div id="tooltip" v-if="show">
          <span class="arrow"></span>
          Bienvenue dans votre espace dédié<br />
          commencez par télécharger votre fichier<br />
          pour visualiser les données de votre COOP
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BtnUploadExcel from '@/components/Button/BtnUploadExcel';
import BtnDownloadExcel from '@/components/Button/BtnDownloadExcel';

export default {
  components: {
    BtnUploadExcel,
    BtnDownloadExcel,
  },
  data() {
    return {
      show: false,
    };
  },
  methods: {
    showTooltip() {
      setTimeout(() => {
        this.show = true;
      }, 1000);
    },
    hideTooltip() {
      this.show = false;
    },
  },
  mounted() {
    if (
      this.$store.state.userInfos.importing === false &&
      this.$store.state.userInfos.optimizing === false &&
      this.$store.state.userInfos.exporting === false
    ) {
      this.showTooltip();
    }
    if (this.$store.state.userInfos.inconsistance === true) {
      this.$toasted.show(this.$store.state.userInfos.inconsistanceMsg, {
        type: 'error',
      });
    }
  },
};
</script>

<style lang="scss" scoped>
.push-top {
  // TEMPORARY FIX FOR WRONG APP ARCHITECTURE -- Ryo
  position: absolute;
  bottom: 50vh;
  width: 100%;
  z-index: 500;
}

.tooltip-wrapper {
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-top: 10px;

  #tooltip {
    background: #f8a331;
    border-radius: 0.25rem;
    color: #fff;
    display: inline-block;
    margin: 0 auto;
    padding: 10px 15px;
    position: relative;

    .arrow {
      width: 0;
      height: 0;
      border: 0.3125rem solid transparent;
      border-top: none;
      border-bottom: 0.3125rem solid #f8a331;
      position: absolute;
      top: -0.3125rem;
      left: 4.25rem;
    }
  }
}

.tuto-buttons {
  display: flex;
  flex-direction: row;
  justify-content: center;
  width: 100%;


}
</style>
